export const FORM_FIELD = {
  DAY: {
    name: 'dayNumber',
    label: 'Choose a day:',
  },
  TITLE: {
    name: 'title',
    label: 'Blog title: (optional)',
  },
  SHOW_TIME_STAMP: {
    name: 'showTimestamp',
    label: 'Show a time stamp on each post',
  },
};

export const FORM_FIELDS = Object.values(FORM_FIELD);
